/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import NotFoundComponent from '@ts/commons/NotFound';
import { AnalyticsInstance } from '@ts/utils/analytics';
import selectors from '@ts/core/selectors';

export default function NotFound() {
    React.useEffect(() => {
        AnalyticsInstance.wpageview();
    }, []);
    const destinations = useSelector(selectors.search.makeSelectDestinations());
    return <NotFoundComponent destinations={destinations} />;
}
